module.exports = __webpack_public_path__ + "static/media/66.0da3b835.png";